module.exports = __webpack_public_path__ + "img/13.f36b5d6b.png";